import React, {Component} from 'react'
import {toJS} from 'mobx'
import {inject, observer} from 'mobx-react'
import {getPaginationConfig} from '../../../../components/pagination'
import {Table, Button, Modal, Switch} from 'antd'
import {QuestionCircleFilled, EditOutlined, DeleteOutlined} from '@ant-design/icons'
import FormModal from './FormModal'
import {withTranslation} from 'react-i18next'
import moment from 'moment'

const storage = window.localStorage
const {confirm} = Modal

@inject('intelligentQueryStore')
@observer
class SearchResult extends Component {
  state = {
    addModalVisible: false,
    record: null,
  }

  handleEdit = (record) => {
      this.setState({
        addModalVisible: true,
        record
      })
  }
  handleCancel = () => {
    this.setState({
      addModalVisible: false,
      record: null,
    })
  }
  handleDel = (record) => {
    const {intelligentQueryStore, t} = this.props
    confirm({
      title: t(`general.deleteData`),
      icon: <QuestionCircleFilled/>,
      content: t(`general.sureToDelete`),
      okText: t(`general.delete`),
      cancelText: t(`general.cancel`),
      onOk() {
        intelligentQueryStore.onTerminologyDeleteAction({ids: [record?.id]})
      },
      onCancel() {
      },
    })
    return false
  }
  handlePageChange = (page, pageSize) => {
    const {intelligentQueryStore} = this.props
    intelligentQueryStore.onTerminologyPageNumAction(page, pageSize)
  }
  getRowClassName = (record, index) => {
    let className = ''
    className = index % 2 === 0 ? 'oddRow' : 'evenRow'
    return className
  }
  handleChangeStatus = (record) => {
    const {intelligentQueryStore} = this.props
    intelligentQueryStore.onTerminologyStatusAction(record)
  }

  render() {
    const themeStyle = JSON.parse(storage.getItem('themeStyle'))
    const {intelligentQueryStore, t} = this.props
    const {pageNo, pageSize, itemCount, terminologyList} = intelligentQueryStore
    const pagination = getPaginationConfig(pageNo, pageSize, itemCount, this.handlePageChange)
    return (
      <>
        <Table className="searchResult" dataSource={toJS(terminologyList)} pagination={pagination} rowKey="id" rowClassName={this.getRowClassName}>
          <Table.Column width={150} title={t(`intelligentQuery.terminologyName`)} dataIndex="word" key="word" ellipsis={true}
            render={(text, record) => (
              <>
                {text}
                {record?.other_words?.length > 0 ? ` （${record?.other_words?.toString()}）` : null}
              </>
            )}
          />
          <Table.Column width={250} title={t(`intelligentQuery.terminologyDesc`)} dataIndex="description" key="description" ellipsis={true}/>
          <Table.Column width={80} align="center" title={t(`general.status`)} dataIndex="enabled" key="enabled"
            render={(text, record) => (
              <Switch
                checked={text}
                onChange={() => {}}
                onClick={(e) => {
                  this.handleChangeStatus({enabled: e, id: record.id})
                }}
                data-record-id={text}
              />
            )}
          />
          <Table.Column width={80} title={t(`general.createTime`)} dataIndex="create_time" key="create_time" ellipsis={true} render={(text, record) => (
            <>
              {moment(text).format('YYYY-MM-DD HH:mm:ss')}
            </>
          )}/>
          <Table.Column width={80} align="center" fixed="right" title={t(`general.action`)} key="Action" render={(text, record) => (
            <>
              <Button type="link" onClick={() => this.handleEdit(record)} icon={<EditOutlined/>} title={t(`general.edit`)}/>
              <Button type="link" onClick={() => this.handleDel(record)} icon={<DeleteOutlined/>} title={t(`general.delete`)}/>
            </>
          )}/>
        </Table>
        {this.state.addModalVisible ? <FormModal
          addModalVisible={this.state.addModalVisible}
          handleCancel={this.handleCancel}
          title="edit"
          record={this.state.record}
        /> : null}
      </>
    )
  }
}

export default withTranslation()(SearchResult)